<template>
  <div>
    <div class="m-auto pb-3 text-center">
      <b-button
        v-if="playTime"
        @click="playPause(false)"
        variant="warning"
        class="rounded-circle p-2 mr-4"
      >
        <i class="material-icons align-middle big-icon">pause</i>
      </b-button>
      <b-button
        v-else
        @click="playPause(true)"
        variant="info"
        class="rounded-circle p-2 mr-4"
      >
        <i class="material-icons align-middle big-icon">play_arrow</i>
      </b-button>
      <b-button
        @click="stop()"
        variant="danger"
        class="rounded-circle p-2"
      >
        <i class="material-icons align-middle big-icon">stop</i>
      </b-button>
    </div>
    <div class="timer-group m-auto text-center">
      <div class="timer hour">
        <div class="hand"><span></span></div>
        <div class="hand"><span></span></div>
      </div>
      <div class="timer minute">
        <div class="hand"><span></span></div>
        <div class="hand"><span></span></div>
      </div>
      <div class="timer second">
        <div class="hand"><span></span></div>
        <div class="hand"><span></span></div>
      </div>
      <div class="face">
        <p id="lazy">{{formattedTimePassed}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};
let animationStatePropertie = [];

export default {
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      playTime: false,
      TIME_LIMIT: this.instance.hours * 3600 + this.instance.minutes * 60
    };
  },
  props: {
    instance: {
      required: true,
      type: Object
    }
  },
  computed: {
    // circleDasharray() {
    //   return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    // },
    
    formattedTimePassed() {
      const timePass = Math.floor(this.timePassed)
      let hours = Math.floor(timePass/3600)
      let minutes = Math.floor((timePass % 3600)/60);
      let seconds = timePass % 60;


      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

       if (hours < 10) {
        hours = `0${hours}`;
      }

      return `${hours}:${minutes}:${seconds}`;
    },
  },
  
  mounted() {
    const $second = document.querySelectorAll('.timer')
    
    let childrenSecond = []
    $second.forEach(element => { 
      childrenSecond.push(element.children)
    })

    childrenSecond.forEach(element => {
      element.forEach(item => {
        animationStatePropertie.push(item.children)
      })
    })
    
  },

  methods: {
    ...mapActions("timer", ["send_minute_spent"]),
    onTimesUp() {
      clearInterval(this.timerInterval);
    },

    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 0.01), 10);
    },

    playPause(play) {
      if (play) {

        animationStatePropertie.forEach(element => {
          element[0].classList.toggle('play')
        });
        
        this.playTime = true;
        this.startTimer();
      } else {
         animationStatePropertie.forEach(element => {
          element[0].classList.toggle('play')
        });
        this.playTime = false;
        clearInterval(this.timerInterval);
      }
    },

    stop() {
      animationStatePropertie.forEach(element => {
        element[0].classList.toggle('play')
      });
      this.playTime = false;
      clearInterval(this.timerInterval);
      this.instance.showMsgConfirm(this.timePassed);
    }
  }
};
</script>

<style scoped>
:root {
  --main-bg-color: paused;
}

.timer-group {
  height: 350px;
  margin: 0 auto;
  position: relative;
  width: 350px;
}

.timer {
  border-radius: 50%;
  height: 50px;
  overflow: hidden;
  position: absolute;
  width: 50px;
}

.timer:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 30px;
  left: 10px;
  position: absolute;
  width: 30px;
  top: 10px;
}

.timer .hand {
  float: left;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 50%;
}

.timer .hand span {
  border: 50px solid rgba(0, 255, 255, 0.4);
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 50%;
  display: block;
  height: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: rotate(225deg);
  width: 0;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-play-state: paused;
}

.play {
  animation-play-state: running !important;
}

.timer .hand:first-child {
  transform: rotate(180deg);
}

/* .timer .hand span {
  
  animation-play-state: pauys;
} */

.timer .hand:first-child span {
  animation-name: spin1;
}

.timer .hand:last-child span {
  animation-name: spin2;
}

.timer.hour {
  background: rgba(24, 201, 214, 0.1);
  height: 350px;
  left: 0;
  width: 350px;
  top: 0;
}

.timer.hour .hand span {
  animation-duration: 3600s;
  border-top-color: rgba(24, 201, 214, 0.6);
  border-right-color: rgba(24, 201, 214, 0.6);
  border-width: 175px;
}

.timer.hour:after {
  height: 310px;
  left: 20px;
  width: 310px;
  top: 20px;
}

.timer.minute {
  background: rgba(24, 201, 214, 0.1);
  height: 300px;
  left: 25px;
  width: 300px;
  top: 25px;
}

.timer.minute .hand span {
  animation-duration: 60s;
  border-top-color: rgba(24, 201, 214, 0.4);
  border-right-color: rgba(24, 201, 214, 0.4);
  border-width: 150px;
}

.timer.minute:after {
  height: 260px;
  left: 20px;
  width: 260px;
  top: 20px;
}

.timer.second {
  background: #ffffff;
  height: 250px;
  left: 50px;
  width: 250px;
  top: 50px;
}

.timer.second .hand span {
  animation-duration: 1s;
  border-top-color: rgba(24, 201, 214, 0.1);
  border-right-color: rgba(24, 201, 214, 0.1);
  border-width: 125px;
}

.timer.second:after {
  height: 246px;
  left: 2px;
  width: 246px;
  top: 2px;
}

.face {
  background: rgba(24, 201, 214, 0.1);
  border-radius: 50%;
  height: 246px;
  left: 52px;
  padding: 165px 40px 0;
  position: absolute;
  width: 246px;
  text-align: center;
  top: 52px;
}

.face h2 {
  font-weight: 300;
}

.face p {
  border-radius: 20px;
  font-size: 54px;
  font-weight: 400;
  position: absolute;
  top: 35%;
  left: 20px;
}

@keyframes spin1 {
  0% {
    transform: rotate(225deg);
  }
  50% {
    transform: rotate(225deg);
  }
  100% {
    transform: rotate(405deg);
  }
}

@keyframes spin2 {
  0% {
    transform: rotate(225deg);
  }
  50% {
    transform: rotate(405deg);
  }
  100% {
    transform: rotate(405deg);
  }
}
</style>
